import { defineComponent as _defineComponent } from 'vue'
export interface ClvrFloatingCardProps {
    top?: boolean
    bottom?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClvrFloatingCard',
  props: {
    top: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { top: boolean, bottom: boolean }



return { __sfc: true,props }
}

})